import * as coreLocales from "@mui/material/locale";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as datePickerLocales from "@mui/x-date-pickers/locales";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { supportedLanguages } from "shared/i18n";
import "dayjs/locale/en";
import "dayjs/locale/pl";

export const withTheme = (children) => () => {
  const { i18n } = useTranslation();

  const themeWithLocale = React.useMemo(
    () =>
      createTheme(
        {
          palette: {
            primary: {
              main: "#002664",
            },
          },
          components: {
            MuiTab: {
              styleOverrides: {
                root: {
                  textTransform: "none",
                },
              },
            },
            MuiAccordion: {
              styleOverrides: {
                root: {
                  "&.Mui-expanded": {
                    color: "#002664",
                  },
                },
              },
            },
            // overrides global p margin style set last-styczen
            MuiTablePagination: {
              styleOverrides: {
                selectLabel: {
                  margin: 0,
                },
                displayedRows: {
                  margin: 0,
                },
              },
            },
            MuiButton: {
              styleOverrides: {
                root: {
                  textTransform: "none",
                },
              },
            },
            // Overriding mui to match bootstrap styles 🤮
            MuiOutlinedInput: {
              styleOverrides: {
                root: {
                  borderRadius: "0.375rem",
                  height: "38px",
                  "& > fieldset": {
                    borderColor: "#ced4da",
                  },
                  "&.MuiOutlinedInput-root:hover": {
                    "& > fieldset": {
                      borderColor: "#ced4da",
                    },
                  },
                  "&.MuiOutlinedInput-root.Mui-focused": {
                    "& > fieldset": {
                      borderColor: "#86b7fe",
                    },
                  },
                  "&.MuiOutlinedInput-root.Mui-disabled": {
                    backgroundColor: "#e9ecef",
                    "& > fieldset": {
                      borderColor: "#ced4da",
                    },
                  },
                  "& .MuiInputBase-input.Mui-disabled": {
                    WebkitTextFillColor: "#212529",
                  },
                },
              },
            },
          },
        },
        datePickerLocales[supportedLanguages[i18n.language]],
        coreLocales[supportedLanguages[i18n.language]]
      ),
    [i18n.language]
  );

  return (
    <ThemeProvider theme={themeWithLocale}>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale={i18n.language}
      >
        {children()}
      </LocalizationProvider>
    </ThemeProvider>
  );
};
